var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Project } from '@/models/Project';
import ErrorHandler from '@/support/ErrorHandler';
import { Component, Prop, Vue } from 'vue-property-decorator';
let EditProjectNameDialog = class EditProjectNameDialog extends Vue {
    // #endregion
    // #region @Refs
    // #endregion
    // #region Class properties
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    close() {
        this.$emit('input', false);
    }
    // #endregion
    // #region Async methods (api calls only)
    async onSubmit() {
        try {
            await this.project.update();
            this.$emit('projectUpdated');
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    // #endregion
    // #region Getters & Setters
    get isDisabled() {
        return !this.project === null || (!!this.project.name && this.project.name.trim() === '');
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Project !== "undefined" && Project) === "function" ? _a : Object)
], EditProjectNameDialog.prototype, "project", void 0);
EditProjectNameDialog = __decorate([
    Component({})
], EditProjectNameDialog);
export default EditProjectNameDialog;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
